import { Box, Button, Drawer, IconButton, Typography } from "@mui/material";
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import TradeApplication from "./TradeApplication";
import { useDispatch } from "react-redux";
import CancelRoundedIcon from '@mui/icons-material/CancelRounded';
import { useCallback, useEffect, useState } from "react";
import { getUsersAllData } from "../../../../actions/usersAllData";



const AccountTypeDrawer = ({ open, onClose, item }) => {
    const [selected, setSelected] = useState(null);
    const [openApplication, setOpenApplication] = useState(false);
    const [type, setType] = useState("");
    const [updateType, setUpdateType] = useState(false);

    // hooks
    const dispatch = useDispatch();

    // Local State
    const [loading, setloading] = useState(true);
    const [Data, setData] = useState([]);

    // Api calls for get Order
    const getData = useCallback(
        async () => {
            const res = await dispatch(getUsersAllData(item?._id, "business"));
            setData(res?.data?.data);
            setloading(false);
        },
        [dispatch, item?._id]
    );

    useEffect(() => {
        getData()

    }, [open, item?._id, updateType]);
    useEffect(() => {
        onCloseApplication()

    }, [updateType]);


    // console.log("data", Data, item)


    const handleApplication = (type) => {
        setOpenApplication(true);
        setType(type)
    }

    const onCloseApplication = () => { setOpenApplication(false) };


    return (
        <>
            <Drawer anchor="right"
                open={open}
                onClose={onClose}
                sx={{
                    "& .MuiDrawer-paper": {
                        top: "0px  !important",
                        backgroundColor: "#fafafa",
                        padding: "10px",
                    },
                    "& .css-i9fmh8-MuiBackdrop-root-MuiModal-backdrop": {
                        top: "0px !important"
                    }
                }}>
                <Box sx={{ marginX: "auto", marginTop: "25px" }} >
                    <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                        <Box sx={{ display: "flex", flexDirection: "column", }}>
                            <Typography
                                className="sofiaRegular"
                                variant="body1"
                                fontWeight="bold"
                                sx={{ fontSize: "16px" }}
                            >
                                Account Type & Applications
                            </Typography>
                            <Typography
                                variant="body2"
                                sx={{ fontSize: "14px", color: "#211f1f", fontFamily: "Sofia Pro, sans-serif !important", }}
                            >
                                Personal Account
                            </Typography>
                        </Box>
                        <Box>
                            <IconButton sx={{ color: 'red', cursor: "pointer", backgroundColor: "transparent", "&:hover": { backgroundColor: "transparent" } }} onClick={onClose}>
                                <CancelRoundedIcon />
                            </IconButton>
                        </Box>
                    </Box>

                    {/* Form Fields */}

                    <Box sx={{ marginBottom: 2, mt: 5, display: "flex", flexDirection: "column", gap: "20px", backgroundColor: "#ffffff", padding: "10px", borderRadius: "6px" }}>
                        <Box>
                            <Typography variant="body1" sx={{ fontSize: "16px", fontWeight: "bold", fontFamily: "Sofia Pro, sans-serif !important", }}>
                                Switch Account Types
                            </Typography>
                            <Typography variant="p" sx={{ fontSize: "14px", fontFamily: "Sofia Pro, sans-serif !important", }}>
                                Override Customer Account Type
                            </Typography>
                        </Box>
                        <Box sx={{ display: "flex", flexDirection: "column", gap: "20px", fontFamily: "Sofia Pro, sans-serif !important", }}>
                            <Button
                                onClick={() => setSelected("personal")}
                                sx={{
                                    fontFamily: "Sofia Pro, sans-serif !important",
                                    textAlign: "left",
                                    display: "block",
                                    border: selected === "personal" ? "2px solid #333" : "1px solid #333",
                                    backgroundColor: "#fafafa",
                                    borderRadius: "6px",
                                    color: "#000",
                                    padding: "4px 10px !important",
                                    "&:hover": {
                                        backgroundColor: "#f0f0f0",
                                    },

                                }}
                                fullWidth
                            >
                                <Box sx={{
                                    width: "100%", display: "flex", backgroundColor: "#fafafa", alignItems: "center", gap: 1, textTransform: "none", justifyContent: "space-between",
                                    "&:hover": {
                                        backgroundColor: "transparent" // Remove background on hover
                                    }
                                }}>
                                    <Box sx={{ display: "flex", alignItems: "center", paddingLeft: "8px" }}>
                                        <Box sx={{ paddingRight: "8px", lineHeight: 0 }}>
                                            <img src="/assets/images/user/profile black copy.svg" width={20} />
                                        </Box>
                                        <Box sx={{
                                            "&:hover": {
                                                backgroundColor: "transparent"
                                            }
                                        }}>
                                            <Typography sx={{ fontWeight: "bold", fontSize: "16px", lineHeight: "1", color: "#000000", fontFamily: "Sofia Pro, sans-serif !important", }}>
                                                Personal
                                            </Typography>
                                            <Typography className="sofiaRegular" variant="body2" sx={{ fontSize: "16px", color: "#000000" }}>
                                                For the home shopper
                                            </Typography>
                                        </Box>
                                    </Box>
                                    {/* condition for the account type to show the selected personal account if the account type trade and trade+ are not apporved  */}
                                    {(item?.accountType === "personal" ||
                                        ((item?.accountType === "trade" || item?.accountType === "trade+") &&
                                            (Data?.status === "pending" || Data?.status === "rejected"))) && (
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: "4px",
                                                    "&:hover": { backgroundColor: "transparent" },
                                                }}
                                            >
                                                <Typography
                                                    className="sofiaRegular"
                                                    variant="body2"
                                                    sx={{
                                                        fontSize: "16px",
                                                        color: "#000000",
                                                        lineHeight: 1,
                                                        fontWeight: "bold",
                                                        display: "flex",
                                                        alignItems: "center",
                                                    }}
                                                >
                                                    Selected
                                                    <img
                                                        src="/assets/images/user/Tick-transparent.png"
                                                        width={16}
                                                        style={{
                                                            marginTop: "2px",
                                                            marginLeft: "4px",
                                                            color: "#333",
                                                        }}
                                                    />
                                                </Typography>
                                            </Box>
                                        )}
                                </Box>
                            </Button>

                            <Button
                                onClick={() => setSelected("trade")}
                                sx={{
                                    fontFamily: "Sofia Pro, sans-serif !important",
                                    textAlign: "left",
                                    display: "block",
                                    border: selected === "trade" ? "2px solid #333" : "1px solid #333",
                                    backgroundColor: "#fafafa",
                                    borderRadius: "6px",
                                    color: "#000",
                                    padding: "4px 10px !important",
                                    "&:hover": {
                                        backgroundColor: "#f0f0f0",
                                    },

                                }}
                                fullWidth
                            >
                                <Box sx={{ width: "100%", display: "flex", alignItems: "center", gap: 1, textTransform: "none", justifyContent: "space-between" }} >
                                    <Box sx={{ display: "flex", alignItems: "center", paddingLeft: "8px" }}>
                                        <Box sx={{
                                            paddingRight: "8px",
                                            lineHeight: 0,
                                        }}>
                                            <img src="/assets/images/user/bag.png" width={16} />
                                        </Box>
                                        <Box>
                                            <Typography className="sofiaRegular" sx={{ fontWeight: "bold", fontSize: "16px", lineHeight: "1", color: "#000000" }}>
                                                Trade
                                            </Typography>
                                            <Typography className="sofiaRegular" variant="body2" sx={{ fontSize: "16px", color: "#000000" }}>
                                                For the trade professional
                                            </Typography>
                                        </Box>
                                    </Box>

                                    {/* Right Section: Status Display */}
                                    {Data?.accountType === "trade" && (
                                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                            {["pending", "rejected"].includes(Data?.status) && (
                                                <Box sx={{ display: "flex", alignItems: "center", gap: "4px" }}>
                                                    <Typography
                                                        variant="body2"
                                                        className="sofiaRegular"
                                                        sx={{
                                                            fontSize: 16,
                                                            fontWeight: "bold",
                                                            color: "#000",
                                                            lineHeight: 1,
                                                            display: "flex",
                                                            alignItems: "center"
                                                        }}
                                                    >
                                                        {Data?.status.charAt(0).toUpperCase() + Data?.status.slice(1)}
                                                    </Typography>
                                                    <img
                                                        src="/assets/images/user/lock.svg"
                                                        width={12}
                                                        style={{
                                                            margin: "0px 4px",
                                                        }}
                                                    />
                                                </Box>
                                            )}
                                            {Data?.status === "approved" && (
                                                <Box sx={{ display: "flex", alignItems: "center", gap: "4px" }}>
                                                    <Typography
                                                        className="sofiaRegular"
                                                        variant="body2"
                                                        sx={{ fontSize: 16, fontWeight: "bold", color: "#000", lineHeight: 1, display: "flex", alignItems: "center" }}
                                                    >
                                                        Selected
                                                        <img
                                                            src="/assets/images/user/tick.svg"
                                                            width={16}
                                                            style={{ marginLeft: "4px", filter: "grayscale(100%) invert(1) brightness(0)" }}
                                                        />
                                                    </Typography>
                                                </Box>
                                            )}
                                        </Box>
                                    )}
                                    {Data?.accountType !== "trade" && item?.businessUpgrade === "Not Applied" && (
                                        <Box>
                                            <Typography variant="body2" sx={{ fontSize: "16px", color: "#000000", lineHeight: 1, fontWeight: "bold" }}>
                                                <img src="/assets/images/user/lock.svg" width={12} style={{ paddingBottom: "2px", marginRight: "4px", color: "#333", fill: "#000", filter: "invert(1) brightness(0)" }} />
                                            </Typography>
                                        </Box>)}
                                </Box>
                            </Button>
                            <Button
                                onClick={() => setSelected("trade+")}
                                sx={{
                                    fontFamily: "Sofia Pro, sans-serif !important",
                                    textAlign: "left",
                                    display: "block",
                                    border: selected === "trade+" ? "2px solid #333" : "1px solid #333",
                                    backgroundColor: "#fafafa",
                                    borderRadius: "6px",
                                    padding: "4px 10px !important",
                                    color: "#000",
                                    "&:hover": {
                                        backgroundColor: "#f0f0f0",
                                    },

                                }}
                                fullWidth
                            >
                                <Box
                                    sx={{
                                        width: "100%",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 1,
                                        textTransform: "none",
                                        justifyContent: "space-between",
                                    }}
                                >
                                    {/* Left Section: Icon & Text */}
                                    <Box sx={{ display: "flex", alignItems: "center", paddingLeft: "8px" }}>
                                        <Box sx={{ marginRight: "6px", lineHeight: 0 }}>
                                            <img src="/assets/images/user/Trade.png" width={20} />
                                        </Box>
                                        <Box>
                                            <Typography className="sofiaRegular" sx={{ fontWeight: "bold", fontSize: 16, lineHeight: 1, color: "#000" }}>
                                                Trade +
                                            </Typography>
                                            <Typography className="sofiaRegular" variant="body2" sx={{ fontSize: 16, color: "#000" }}>
                                                Trade+ tax exempt checkout
                                            </Typography>
                                        </Box>
                                    </Box>

                                    {/* Right Section: Status Display */}
                                    {Data?.accountType === "trade+" && (
                                        <Box sx={{ display: "flex", alignItems: "center" }}>
                                            {["pending", "rejected"].includes(Data?.status) && (
                                                <Box sx={{ display: "flex", alignItems: "center", gap: "4px" }}>
                                                    <Typography
                                                        variant="body2"
                                                        className="sofiaRegular"
                                                        sx={{
                                                            fontSize: 16,
                                                            fontWeight: "bold",
                                                            color: "#000",
                                                            lineHeight: 1,
                                                            display: "flex",
                                                            alignItems: "center"
                                                        }}
                                                    >
                                                        {Data?.status.charAt(0).toUpperCase() + Data?.status.slice(1)}
                                                    </Typography>
                                                    <img
                                                        src="/assets/images/user/lock.svg"
                                                        width={12}
                                                        style={{
                                                            margin: "0px 4px",
                                                            filter: "invert(1) brightness(0)",
                                                        }}
                                                    />
                                                </Box>

                                            )}
                                            {Data?.status === "approved" && (
                                                <Box sx={{ display: "flex", alignItems: "center", gap: "4px" }}>
                                                    <Typography
                                                        className="sofiaRegular"
                                                        variant="body2"
                                                        sx={{ fontSize: 16, fontWeight: "bold", color: "#000", lineHeight: 1, display: "flex", alignItems: "center" }}
                                                    >
                                                        Selected
                                                        <img
                                                            src="/assets/images/user/tick.svg"
                                                            width={16}
                                                            style={{ marginLeft: "4px", filter: "grayscale(100%) invert(1) brightness(0)" }}
                                                        />
                                                    </Typography>
                                                </Box>
                                            )}
                                        </Box>
                                    )}
                                    {Data?.accountType !== "trade+" && item?.businessUpgrade === "Not Applied" && (
                                        <Box>
                                            <Typography variant="body2" sx={{ fontSize: "16px", color: "#000000", lineHeight: 1, fontWeight: "bold" }}>
                                                <img src="/assets/images/user/lock.svg" width={12} style={{ paddingBottom: "2px", marginRight: "4px", color: "#333", fill: "#000", filter: "invert(1) brightness(0)" }} />
                                            </Typography>
                                        </Box>)}
                                </Box>

                            </Button>
                        </Box>
                    </Box>
                    <Button
                        onClick={() => handleApplication("trade")}
                        sx={{
                            fontFamily: "Sofia Pro, sans-serif !important",
                            textAlign: "left",
                            display: "block",
                            padding: "4px 10px !important",
                            height: "70px",
                            border: selected === "trade" ? "2px solid #e1e5e8" : "1px solid #e1e5e8",
                            backgroundColor: "#fff",
                            borderRadius: "6px",
                            color: "#000",
                            "&:hover": {
                                backgroundColor: "#fff",
                            },

                        }}
                        fullWidth
                    >

                        <Box sx={{ width: "100%", display: "flex", alignItems: "center", gap: 1, textTransform: "none", justifyContent: "space-between" }} >
                            {/* Checkbox */}
                            <Box sx={{ display: "flex", alignItems: "center", }}>
                                <Box sx={{ paddingRight: "9px", marginLeft: "16px" }}>
                                    <img src="/assets/images/user/bag.png" width={16} />
                                </Box>
                                <Box>
                                    <Typography sx={{ fontWeight: "bold", fontSize: "16px", lineHeight: 1, color: "#000000", fontFamily: "Sofia Pro, sans-serif !important", }}>
                                        Trade Application
                                    </Typography>
                                    <Typography variant="body2" sx={{ fontSize: "16px", color: "#000000", fontFamily: "Sofia Pro, sans-serif !important", lineHeight: 0.9 }}>
                                        Home Businesses
                                    </Typography>
                                </Box>
                            </Box>
                            {Data?.accountType === "trade" && Data?.status === "pending" && <Box sx={{ display: "flex", alignItems: "center", fontFamily: "Sofia Pro, sans-serif !important", }}>
                                <Typography variant="body2" sx={{ fontSize: "20px", color: "#ffb706", lineHeight: 1, fontWeight: "bold" }}>
                                    ! <KeyboardArrowRightIcon sx={{ fontSize: "20px", color: "#333", marginBottom: "3px" }} />
                                </Typography>
                            </Box>}
                        </Box>
                    </Button>
                    <Button
                        onClick={() => handleApplication("trade+")}
                        sx={{
                            fontFamily: "Sofia Pro, sans-serif !important",
                            textAlign: "left",
                            display: "block",
                            border: selected === "trade+" ? "2px solid #e1e5e8" : "1px solid #e1e5e8",
                            backgroundColor: "#fff",
                            borderRadius: "6px",
                            padding: "4px 10px !important",
                            height: "70px",
                            color: "#000",
                            "&:hover": {
                                backgroundColor: "#fff",
                            },
                            marginTop: "16px"
                        }}
                        fullWidth
                    >

                        <Box sx={{ width: "100%", display: "flex", alignItems: "center", gap: 0.5, textTransform: "none", justifyContent: "space-between" }} >
                            {/* Checkbox */}
                            <Box sx={{ display: "flex", alignItems: "center", paddingLeft: "16px" }}>
                                <Box sx={{ paddingRight: "8px" }}>
                                    <img src="/assets/images/user/Trade.png" width={20} />
                                </Box>
                                <Box>
                                    <Typography className="sofiaRegular" sx={{ fontWeight: "bold", fontSize: "16px", lineHeight: 1, color: "#000000" }}>
                                        Trade  + Application
                                    </Typography>
                                    <Typography className="sofiaRegular" variant="body2" sx={{ fontSize: "16px", color: "#000000", lineHeight: 0.9 }}>
                                        Home Businesses with valid resale certificate
                                    </Typography>
                                </Box>
                            </Box>
                            {Data?.accountType === "trade+" && <Box sx={{ display: "flex", alignItems: "center", fontFamily: "Sofia Pro, sans-serif !important", }}>
                                <Typography variant="body2" sx={{ fontSize: "16px", color: Data?.status === "pending" ? "#ffb500" : Data?.status === "rejected" ? "#9f0e12" : "#13a755", lineHeight: 1, fontWeight: "bold" }}>
                                    !
                                </Typography>
                            </Box>}
                            <Box sx={{ display: "flex", alignItems: "center" }}>
                                <Typography className="sofiaRegular" variant="body2" sx={{ fontSize: "20px", color: "#ffb706", lineHeight: 1, fontWeight: "bold" }}>
                                    <KeyboardArrowRightIcon sx={{ fontSize: "20px", color: "#333", marginBottom: "3px" }} />
                                </Typography>
                            </Box>
                        </Box>
                    </Button>
                </Box>
            </Drawer>
            {openApplication && <TradeApplication open={handleApplication} onClose={onCloseApplication} type={type} item={Data} setUpdateType={setUpdateType} updateType={updateType} />}

        </>
    );
};

export default AccountTypeDrawer